export default __webpack_public_path__ + "static/media/Anushka Khanduri.147697ec.jpeg";